export default 'customerEdit';
